import { api } from 'common';

import { CodeMirrorAutocompleteProvider } from '../../../../../Code/codeMirrorHooks';
import { type AutocompleteLabels } from '../../../../../Code/types';
import { SharedFunctionBlockFormFields } from '../../../ConfigFields/JavaScriptBlock/FormFields';
import { SharedLlmBlockFormFields } from '../../Llm/Shared/SharedFormFields';
import { SharedRestBlockFormFields } from '../../Rest/Shared/FormFields';
import { SharedSubFlowV1BlockFormFields } from '../../SubFlow/v1/SharedFormFields';

type BlockType = api.FlowDefinition.BlockType;

interface IteratorActionBlockFormFieldsProps {
  blockType: BlockType;
}

// Explanation of this prefix:
//   - config.action: the top-level field in the iterator block that contains the action block
//   - .config: the action block's config
const fieldNamePrefix = 'config.action.config';

const additionalAutoCompleteLabels: AutocompleteLabels = [
  'iterationItem',
  'iterationItem.data',
  'iterationItem.index',
  'iterationItem.totalItemCount',
] as const;

function IteratorActionBlockFormFieldsByBlockType(props: { blockType: BlockType }) {
  const { blockType } = props;

  switch (blockType) {
    case api.FlowDefinition.BlockType.LlmPrompt:
      return <SharedLlmBlockFormFields fieldNamePrefix={fieldNamePrefix} />;
    case api.FlowDefinition.BlockType.ScriptedFlow:
      return <SharedFunctionBlockFormFields fieldNamePrefix={fieldNamePrefix} />;
    case api.FlowDefinition.BlockType.Rest:
      return <SharedRestBlockFormFields fieldNamePrefix={fieldNamePrefix} />;
    case api.FlowDefinition.BlockType.SubFlowV1:
      return <SharedSubFlowV1BlockFormFields fieldNamePrefix={fieldNamePrefix} />;
    default:
      throw new Error(`Unsupported action type: ${blockType}`);
  }
}

export function IteratorActionBlockFormFields(props: IteratorActionBlockFormFieldsProps) {
  const { blockType } = props;

  return (
    <CodeMirrorAutocompleteProvider
      memoizedAdditionalAutoCompleteLabels={additionalAutoCompleteLabels}
    >
      <IteratorActionBlockFormFieldsByBlockType blockType={blockType} />
    </CodeMirrorAutocompleteProvider>
  );
}
